<div class="filter-slideout">
  <div class="filter-slideout__main">
    <atn-rate-gl-filter
      [filter]="
        glRecordEc.plugins.currentListPlugin.editedParams.selectors.filters.asSignal()
      "
      (filterChange)="
        this.glRecordEc.plugins.currentListPlugin.editedParams.actions.setFilters
          .from('FilterSlideout')
          .dispatch($event)
      "
    />
  </div>
  <div class="filter-slideout__footer">
    <atn-ds-button
      class="filter-slideout__footer-create-rule-btn"
      type="transparent"
      (click)="createRuleHandler()"
      >Create Rule</atn-ds-button
    >
    <atn-ds-button
      class="filter-slideout__footer-cancel-btn"
      type="transparent"
      (click)="closeClick.emit()"
      >Cancel</atn-ds-button
    >
    <atn-ds-button (click)="saveBtnClickHandler()">Save</atn-ds-button>
  </div>
</div>
